export default __webpack_public_path__ + "static/gem-light.png";